import { useDataTableParamState } from "@/common/hooks/useDataTableParamState";
import { getDefaultColumnStates } from "@/common/utils/datatable";
import { GroupingColumn } from "@/feature/components/TableDisplayModePicker";
import { EntityFlagDTO } from "@reflag/shared/flagAPI";
import { UsersSortByColumn } from "@reflag/shared/userAPI";

export type CompanyFlagsColumn = keyof EntityFlagDTO;

export const groupingCompanyFlagsColumns = [
  { id: "value", label: "Access" },
  { id: "createdAt", label: "Created" },
] as const satisfies GroupingColumn<CompanyFlagsColumn>[];

const allowedGroupingColumns = groupingCompanyFlagsColumns.map((col) => col.id);

export const defaultCompanyFlagsColumns = [
  "name",
  "value",
  "firstExposureAt",
  "lastExposureAt",
  "exposureCount",
  "createdAt",
] as const satisfies Array<CompanyFlagsColumn>;

export const useCompanyFlagsTableState = () =>
  useDataTableParamState<CompanyFlagsColumn, CompanyFlagsColumn>({
    sorting: [{ id: "createdAt", desc: true }],
    columnStates: getDefaultColumnStates(defaultCompanyFlagsColumns),
    groupingColumn: "value",
    allowedGroupingColumns,
  });

export const useCompanyUsersTableState = () =>
  useDataTableParamState<UsersSortByColumn, UsersSortByColumn>({
    sorting: [{ id: "lastSeen", desc: true }],
  });
